<template>
	<div>
		<OverviewTitleBox :title="'STORE'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">STORE</H6>
		</div>
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCardComp icon="fa-chart-line" prefix="SALES" unit="M" div=1000000 :data="ytd.sales.rekap[3]" infocol="Info" valuecol="Value" comp=1 :url="'/bright/report2?' + this.getYesterdayfilter('dateStart', 'dateEnd') +'&tab=0&period=daily&area=area' "/> <!-- /bright/sales -->
				<InfoCardComp icon="fa-plus-square" prefix="MARGIN" unit="%" :data="ytd.margin.rekap[3]" infocol="Info" valuecol="Value" comp=1 :url="'/bright/report2?' + this.getYesterdayfilter('dateStart', 'dateEnd') +'&tab=0&period=daily&area=area' "/> <!-- /bright/sales -->
				<InfoCardComp icon="fa-chart-line" prefix="WASTE" unit="M" div=1000000 :data="ytd.waste.rekap[1]" infocol="Info" valuecol="Value" comp=-1 :url="'/bright/report2?' + this.getMTDfilter('dateStart', 'dateEnd') +'&tab=2&period=monthly&area=area' "/> <!-- /bright/sales -->
			</div>
			<div class="col-md-4">
				<InfoCardComp icon="fa-store" prefix="SPD" unit="M" div=1000000 :data="ytd.sales.spd[3]" infocol="Info" valuecol="Value" comp=1 :url="'/bright/report2?' + this.getYesterdayfilter('dateStart', 'dateEnd') +'&tab=1&period=daily&area=' "/> <!-- /bright/sales -->
				<InfoCardComp icon="fa-chart-line" prefix="TRAFFIC" unit="" div=1 :data="ytd.basket.invoice[3]" infocol="Info" valuecol="Value" comp=1 :url="'/bright/report2?' + this.getYesterdayfilter('dateStart', 'dateEnd') +'&tab=0&period=daily&area=' "/> <!-- /bright/sales -->
				<InfoCardComp icon="fa-chart-line" prefix="TOTAL" unit="STORE" :data="ytd.store.rekap[0]" infocol="Info" valuecol="Value" div=1 comp=1 url="/bright/storelist?status=1"/> <!-- /bright/storelist -->
				<!--<InfoCardComp icon="fa-chart-line" prefix="BASKET SIZE" unit="RP" div=1 :data="ytd.basket.size[3]" infocol="Info" valuecol="Value" comp=1 url="/bright/sales"/>-->
				<!--
				<InfoCardComp icon="fa-box-open" prefix="TOP ITEM OOS" unit="%" :data="stock.oos.compitem" infocol="StockDate" valuecol="PctItem" comp=-1 url="/bright/stock"/>
				<InfoCardComp icon="fa-store-slash" prefix="STORE OOS" unit="" :data="stock.oos.compstore" infocol="StockDate" valuecol="CountBranch" comp=-1 url="/bright/stock"/>
				<InfoCardComp icon="fa-trash-alt" prefix="WASTE WEEK" unit="M" div=1000000 :data="weekly.compwaste" infocol="WeekNo" valuecol="Waste" comp=-1 url="/bright/sales"/>
				-->
			</div>
			<div class="col-md-4">
				<InfoCardComp icon="fa-truck-moving" prefix="SL SUPPLIER (LINE FILL) WEEK" unit="%" :data="weekly.compslsdline" infocol="WeekNo" valuecol="LineFillPct" comp=1 :url="'/bright/report2?' +'tab=5' + '&sltype=sls' + '&sltypeline=linefill' "/> <!-- /bright/sl -->
				<InfoCardComp icon="fa-truck" prefix="SL DC (LINE FILL) WEEK" unit="%" :data="weekly.compsldline" infocol="WeekNo" valuecol="LineFillPct" comp=1 :url="'/bright/report2?' +'tab=5' + '&sltype=sld' + '&sltypeline=linefill' "/> <!-- /bright/sl -->
			</div>
		</div>

        <div class="row mb-4" style="margin-top: -20px;">
			<div class="col-md-3">
				<InfoCard info="TOTAL STORE OOS BY AREA" :value="totalOOSStoreByArea" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="STORE OOS BY AREA" :data="oosStoreBySalesArea" prefix="AREA" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=BRIGHT"/>
			</div>

			<div class="col-md-3">
				<InfoCard info="TOTAL STORE OOS BY REGION" :value="totalOOSStoreByRegion" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="STORE OOS BY REGION" :data="oosStoreByRegion" prefix="REGION" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=BRIGHT"/>
			</div>

            <div class="col-md-3">
				<InfoCard info="TOTAL DC OOS BY AREA" :value="totalOOSDCByArea" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="DISTRIBUTION CENTER BY AREA" :data="oosDCBySalesArea" prefix="AREA" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=DC"/>
			</div>

			<div class="col-md-3">
				<InfoCard info="TOTAL DC OOS BY REGION" :value="totalOOSDCByRegion" unit="UNIT"
					:url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'" :loading="this.loading.oos" />
                <ListItem5 warning=1 title="DISTRIBUTION CENTER OOS BY REGION" :data="oosDCByRegion" prefix="REGION" itemcol="title" valuecol="Cnt"
                    url="/bright/report2?tab=10&branchtype=DC"/>
			</div>

		</div>

	</div>
</template>

<script>
import Bright from '@/components/page/Bright.js'
import InfoCardComp from '@/views/pages/InfoCardComp.vue'
import ListItem5 from '@/views/pages/ListItem5.vue'
import InfoCard from '@/views/pages/InfoCard.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'
import { Rainbow, Rainbow2, FuelColor, Config, AppColors, Penanggalan, AxiosWithJar } from '@/utility.js'

export default {
	extends: Bright,
	components:{
		InfoCardComp,
		OverviewTitleBox,
        ListItem5,
        InfoCard,
	},
    data() {
        return {
            oos: [],
            loading: {
                oos: false,
            }
        }
    },
    mounted(){
		this.loadYTD();
		this.loadWeekly();
        this.getOOSOverview();
		this.loadOOS();
    },
    methods:{
		async loadYTD() {
			let url = Config().apiURL + "/bright/ytd-overview?" + (this.branchid ? "&branchid=" + this.branchid : "")
			await AxiosWithJar().get(url).then(result => {
				if (result.data.sales.length) {
					this.ytd.sales = {
						rekap: this.processYTD(result.data.sales, "Info", "SalesExTax", false, "Grup", 1, 2),
						spd: this.processYTD(result.data.sales, "Info", "TotalSPD", "StoreCount", "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", false, "SalesArea", "AREA ", 1000000000, 2, Rainbow2, "Grup", [2], true),
						spdchart: this.processBarChart(result.data.sales, "Info", "", "SalesExTax", "StoreCount", "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [4], true, false, "NumDay"),
					};
					this.ytd.margin = {
						rekap: this.processYTD(result.data.margin, "Info", "Margin", "SalesExTax", "Grup", 0.01, 2),
						ytdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.margin, "Info", "", "Margin", "SalesExTax", "SalesArea", "AREA ", 0.01, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.waste = {
						rekap: this.processYTD(result.data.waste, "Info", "Waste", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.waste, "Info", "", "Waste", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.waste, "Info", "", "Waste", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.reconcile = {
						rekap: this.processYTD(result.data.reconcile, "Info", "Reconcile", false, "Grup", 1, 2),
						ytdchart: this.processBarChart(result.data.reconcile, "Info", "", "Reconcile", false, "SalesArea", "AREA ", 1000000, 2, Rainbow, "Grup", [1], true),
						mtdchart: this.processBarChart(result.data.reconcile, "Info", "", "Reconcile", false, "SalesArea", "AREA ", 1000000, 2, Rainbow2, "Grup", [2], true),
					};
					this.ytd.basket = {
						invoice: this.processYTD(result.data.basket, "Info", "NoOfInvoice", false, "Grup", 1, 2),
						size: this.processYTD(result.data.basket, "Info", "SalesExTax", "NoOfInvoice", "Grup", 1, 2, false),
					};
					this.ytd.store = {
						rekap: this.processYTD(result.data.store, "Info", "TotalStore", false, "Grup", 1, 2),
					}
				}
			})
		},
        async getOOSOverview() {
            this.urlRequestParams=Config().apiURL
            this.urlRequestParams+='/v1/bright/oosoverview?'

            //
            //this.urlRequestParams+='&date='+this.tanggal

            this.loading.oos = true
            //this.loading.isSuccess = false;
            AxiosWithJar().get(this.urlRequestParams)
                .then((response)=>{
                    this.oos = response.data;
                    //this.loading.isSuccess = true;
                    console.log('oos overview: ' + JSON.stringify(this.oos));
                })
                .catch(error => {
                    console.log(error)
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.oos = false;
                })
        },
	},
    computed: {
        //OOS
        totalOOSStoreByArea() {
            return this.oos?.oos_store_by_sales_area?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSStoreByRegion() {
            return this.oos?.oos_store_by_region?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSDCByArea() {
            return this.oos?.oos_dc_by_sales_area?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },
        totalOOSDCByRegion() {
            return this.oos?.oos_dc_by_region?.data?.reduce((acc, item) => acc + item.Cnt, 0);
        },

        //APPEND URL
        oosStoreBySalesArea() {
            return (this.oos?.oos_store_by_sales_area?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&area=${item.title !== null ? item.title : ''}&branchtype=BRIGHT&condition=OOS&presentation=10`
            }));
        },
        oosStoreByRegion() {
            return (this.oos?.oos_store_by_region?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${(item.title !== null ? item.title : '')}&branchtype=BRIGHT&condition=OOS&presentation=10`
            }));
        },
        oosDCBySalesArea() {
            return (this.oos?.oos_dc_by_sales_area?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&area=${(item.title !== null ? item.title : '')}&branchtype=DC&condition=OOS&presentation=10`
            }));
        },
        oosDCByRegion() {
            return (this.oos?.oos_dc_by_region?.data || []).map(item => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${(item.title !== null ? item.title : '')}&branchtype=DC&condition=OOS&presentation=10`
            }));
        },
    },
}
</script>
